<template>
  <div class="modal">
    <slot name="body" />
    <div
      class="video-fullscreen__close"
      @click="handleButtonClick()"
    >
      <i class="icon-close"><span class="path1" /><span class="path2" /></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalView',

  methods: {
    handleButtonClick() {
      this.$emit('closeModal');
    }
  }
};
</script>

<style lang="scss" src="@/assets/components/modal/modal-view.scss"></style>



// WEBPACK FOOTER //
// modal-view.vue